/**
 * Menvora — COD CTA helpers (sin skeleton propio; Releasit ya bloquea/carga el CTA).
 * - Rescue packs/CTA desde #floatingBuyNowButton → form ATF (ads-images)
 * - body.is-rsi-ready + CodCtaReady cuando el CTA RSI está usable
 * - Label CTA + colapso de slot ATF
 */
(function () {
  if (window.__menvoraCodCtaSkeleton) return;
  window.__menvoraCodCtaSkeleton = true;

  var TIMEOUT_MS = 12000;
  var POLL_MS = 250;
  var FLOAT_FALLBACK_MS = 700;
  var startedAt = Date.now();
  var ready = false;
  var atfReadyAt = 0;
  var pollId = 0;
  var observer = null;
  var mq = window.matchMedia('(max-width: 749px)');

  function track(name, params) {
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.track === 'function') {
      window.MenvoraAnalytics.track(name, params || {});
      return;
    }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) {}
  }

  function stackChange() {
    try {
      window.dispatchEvent(new CustomEvent('menvora:cod-cta-stack-change'));
    } catch (e) {}
  }

  function rsiButton() {
    return (
      document.getElementById('rsi_buy_now_button') ||
      document.querySelector('[data-rsi-cod-button="true"]')
    );
  }

  function isPainted(el) {
    if (!el || el.hidden) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width >= 120 && r.height >= 44;
  }

  function isVisibleFixed(el) {
    if (!isPainted(el)) return false;
    return window.getComputedStyle(el).position === 'fixed';
  }

  function floatCtaPainted() {
    var wrap = document.getElementById('floatingBuyNowButton');
    if (isPainted(wrap)) return true;
    var btn = rsiButton();
    if (isVisibleFixed(btn)) return true;
    var alt =
      document.querySelector('#rsi_buy_now_button.rsi_floating') ||
      document.querySelector('#rsi_buy_now_button.rsi_floating_bottom') ||
      document.querySelector('.rsi_floating_bottom');
    return isPainted(alt);
  }

  function rsiButtonHasText(btn) {
    return String(btn ? btn.textContent : '').replace(/\s+/g, '').length > 3;
  }

  function atfCtaPainted() {
    var btn = rsiButton();
    if (!btn) return false;
    if (isVisibleFixed(btn)) return false;
    if (!rsiButtonHasText(btn)) return false;
    if (isPainted(btn)) return true;
    if (isAdsImagesPdp()) {
      var cs = window.getComputedStyle(btn);
      if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
      var r = btn.getBoundingClientRect();
      return r.width >= 80;
    }
    return false;
  }

  function canReady() {
    if (isAdsImagesPdp()) return atfCtaPainted();
    if (isMobile()) {
      if (floatCtaPainted()) return true;
      if (atfCtaPainted()) {
        if (!atfReadyAt) atfReadyAt = Date.now();
        return Date.now() - atfReadyAt >= FLOAT_FALLBACK_MS;
      }
      return false;
    }
    return atfCtaPainted() || floatCtaPainted();
  }

  function atfSlot() {
    return (
      document.querySelector('[data-menvora-ads-images] .product-form__buttons') ||
      document.querySelector('[data-menvora-cod-cta-slot="atf"]')
    );
  }

  function isMobile() {
    return mq.matches;
  }

  function isAdsImagesPdp() {
    return (
      document.body.classList.contains('template-product-ads-images') ||
      !!document.querySelector('[data-menvora-ads-images]')
    );
  }

  function ctaInAtfFlow() {
    var slot = atfSlot();
    var btn = rsiButton();
    if (!slot || !btn) return false;
    if (!slot.contains(btn)) return false;
    if (isVisibleFixed(btn)) return false;
    return isPainted(btn);
  }

  function syncAtfSlotCollapse() {
    var slot = atfSlot();
    if (!slot) return;
    var collapse;
    if (isAdsImagesPdp()) {
      collapse = false;
      rescueAdsImagesCodFromFloat();
    } else if (isMobile()) {
      collapse = true;
    } else if (!ready) {
      collapse = false;
    } else {
      collapse = !ctaInAtfFlow();
    }
    var changed = slot.classList.contains('is-cod-slot-collapsed') !== collapse;
    slot.classList.toggle('is-cod-slot-collapsed', collapse);
    if (changed) stackChange();
  }

  /** ads-images: traer packs + CTA del float al form ATF. */
  function rescueAdsImagesCodFromFloat() {
    var slot = atfSlot();
    if (!slot || !isAdsImagesPdp()) return;
    var form = slot.closest('form') || slot.parentNode;
    var floatWrap = document.getElementById('floatingBuyNowButton');
    if (!form || !floatWrap) return;
    var moved = false;

    function placeBeforeSlot(el) {
      if (!el || el === slot) return;
      if (slot.contains(el) || (form.contains(el) && !floatWrap.contains(el))) return;
      try {
        form.insertBefore(el, slot);
        moved = true;
      } catch (e) {}
    }

    floatWrap.querySelectorAll('[data-qty-skel], .rsi-qty-skel, .rsi-quantity-product').forEach(function (el) {
      var host = el.closest('#buttonContainerProduct') || el.parentElement;
      if (host && host !== floatWrap && floatWrap.contains(host) && host.id === 'buttonContainerProduct') {
        placeBeforeSlot(host);
      } else {
        placeBeforeSlot(el);
      }
    });

    var container = floatWrap.querySelector('#buttonContainerProduct');
    if (container) placeBeforeSlot(container);

    var btn = document.getElementById('rsi_buy_now_button');
    if (btn && !slot.contains(btn)) {
      try {
        slot.appendChild(btn);
        moved = true;
      } catch (e) {}
    }

    Array.prototype.slice.call(floatWrap.children).forEach(function (child) {
      if (!child || child === slot) return;
      placeBeforeSlot(child);
      if (btn && child.contains && child.contains(btn) && !slot.contains(btn)) {
        try {
          slot.appendChild(btn);
          moved = true;
        } catch (e2) {}
      }
    });

    if (moved) stackChange();
  }

  var COD_CTA_LABEL = resolveCodCtaLabel();

  function resolveCodCtaLabel() {
    var root = document.querySelector('[data-menvora-cod-cta-label]');
    if (root) {
      var fromRoot = String(root.getAttribute('data-menvora-cod-cta-label') || '').trim();
      if (fromRoot) return fromRoot;
    }
    return 'Comprar';
  }

  function applyCodCtaLabel() {
    document.querySelectorAll('#rsi_buy_now_button').forEach(function (btn) {
      var current = String(btn.textContent || '').replace(/\s+/g, ' ').trim();
      if (current === COD_CTA_LABEL && btn.getAttribute('aria-label') === COD_CTA_LABEL) {
        return;
      }
      var texts = [];
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (String(n.nodeValue || '').replace(/\s+/g, '').length) texts.push(n);
      }
      if (!texts.length) return;
      texts[0].nodeValue = COD_CTA_LABEL;
      for (var i = 1; i < texts.length; i++) texts[i].nodeValue = '';
      btn.setAttribute('aria-label', COD_CTA_LABEL);
    });
  }

  function watchCodCtaLabel() {
    applyCodCtaLabel();
    [400, 1200, 2500].forEach(function (ms) {
      window.setTimeout(applyCodCtaLabel, ms);
    });
  }

  function finishReady() {
    if (ready) return;
    ready = true;
    document.body.classList.add('is-rsi-ready');
    document.body.classList.remove('is-rsi-handoff');
    stopWatching();
    syncAtfSlotCollapse();
    watchAtfSlotCollapse();
    watchCodCtaLabel();
    stackChange();
    track('CodCtaReady', {
      ms: Date.now() - startedAt,
      label: COD_CTA_LABEL,
    });
    try {
      window.dispatchEvent(new CustomEvent('menvora:cod-cta-ready'));
    } catch (e) {}
  }

  function stopWatching() {
    if (pollId) {
      window.clearInterval(pollId);
      pollId = 0;
    }
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function watchAtfSlotCollapse() {
    syncAtfSlotCollapse();
    var slot = atfSlot();
    if (slot) {
      var obs = new MutationObserver(function () {
        syncAtfSlotCollapse();
      });
      obs.observe(slot, { attributes: true, attributeFilter: ['class'] });
    }
    [200, 800, 2000].forEach(function (ms) {
      window.setTimeout(syncAtfSlotCollapse, ms);
    });
    if (mq.addEventListener) mq.addEventListener('change', syncAtfSlotCollapse);
    else mq.addListener(syncAtfSlotCollapse);
  }

  function tick() {
    if (ready) return;
    syncAtfSlotCollapse();
    if (canReady()) finishReady();
  }

  function init() {
    var slot = atfSlot();
    if (!slot) return;

    tick();

    observer = new MutationObserver(function () {
      if (!ready) tick();
    });
    observer.observe(slot, { childList: true, subtree: true });

    var form = slot.closest('form') || slot.parentElement;
    if (form && form !== slot) {
      observer.observe(form, { childList: true, subtree: true });
    }

    pollId = window.setInterval(tick, POLL_MS);

    window.setTimeout(function () {
      if (!ready) {
        if (canReady()) finishReady();
        else stopWatching();
      }
    }, TIMEOUT_MS);
  }

  function rescueQtySkelFromFloat() {
    if (isAdsImagesPdp()) {
      rescueAdsImagesCodFromFloat();
      return true;
    }
    var floatWrap = document.getElementById('floatingBuyNowButton');
    var slot = atfSlot();
    if (!floatWrap || !slot || !slot.parentNode) return false;
    var qty = floatWrap.querySelector('[data-qty-skel], .rsi-qty-skel');
    if (!qty) return false;
    if (qty.parentElement === slot.parentNode && qty.nextElementSibling === slot) return false;
    try {
      slot.parentNode.insertBefore(qty, slot);
    } catch (err) {
      return false;
    }
    stackChange();
    return true;
  }

  function watchQtyRescue() {
    var moves = 0;
    var MAX_MOVES = isAdsImagesPdp() ? 12 : 4;
    var obs = null;

    function tickRescue() {
      if (moves >= MAX_MOVES) {
        if (obs) obs.disconnect();
        return;
      }
      if (rescueQtySkelFromFloat()) {
        moves += 1;
        if (moves >= MAX_MOVES && obs) obs.disconnect();
      }
    }

    tickRescue();
    var floatWrap = document.getElementById('floatingBuyNowButton');
    if (floatWrap) {
      obs = new MutationObserver(function () {
        tickRescue();
      });
      obs.observe(floatWrap, { childList: true, subtree: true });
    }
    var delays = isAdsImagesPdp()
      ? [100, 300, 600, 1200, 2000, 3500, 5000]
      : [100, 400, 1200];
    delays.forEach(function (ms) {
      window.setTimeout(tickRescue, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
    document.addEventListener('DOMContentLoaded', watchQtyRescue, { once: true });
  } else {
    init();
    watchQtyRescue();
  }
})();
